import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {generateRandomString} from "../../../../utils/helpers";
import {Field, FieldArray, Formik} from "formik";
import FileInput from "../../../../components/Ui/FileInput";
import FileUploader, {MimeTypeIcon} from "../../../../components/Ui/FileUploader";
import clsx from "clsx";
import BootstrapLoadingButton from "../../../../components/Ui/BootstrapLoadingButton";
import axios from 'axios';
import {
    DOWNLOAD_SPECIFIC_DEVIS,
    DOWNLOAD_DOCUMENT,
    FICHE_SEND_DOCUMENTS,
    LOAD_FICHE_DEVIS,
    LOAD_SENDED_DOCUMENTS
} from "../../../../api/Api";
import {useParams} from 'react-router-dom'
import {ProgressBar} from "react-bootstrap";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextArea from "../../../../components/Ui/TextArea";
import Divider from "@material-ui/core/Divider";
import moment from "moment";
import FichePlanRecolementViewer from "../../../../components/Modules/Fiches/FichePlanRecolementViewer";


const useStyles = makeStyles((theme) => ({
    documentItem: {
        width: '100%',
        padding: theme.spacing(1,0),
        borderRadius: 9,
        background: 'white',
        position: 'relative'
    },
}));


export default function DocumentsPage(props) {

    const classes = useStyles()


    const [isLoadingDocuments, setIsLoadingDocuments] = React.useState(false)
    const [documentsSend, setDocumentsSend] = React.useState();

    const [isLoadingDevis,setIsLoadingDevis] = React.useState(false)
    const [devis,setDevis] = React.useState();

    const {id} = useParams();

    async function loadSendedDocuments() {

        setIsLoadingDocuments(true)

        try {

            const response = await axios.get(
                `${LOAD_SENDED_DOCUMENTS}/${id}`
            );

            setDocumentsSend(response.data)

        } catch (e) {

        } finally {
            setIsLoadingDocuments(false)
        }

    }

    async function loadDevis(){

        setIsLoadingDevis(true);

        try{

            const response = await axios.get(
                `${LOAD_FICHE_DEVIS}/${id}`
            );

            setDevis(response.data)

        } catch (e) {
            console.log(e)
        } finally {
            setIsLoadingDevis(false)
        }

    }


    async function  sendDocuments(values, formikHelpers) {

        try {

            let data = values.files.filter(
                item => {
                    return !!values.sendedFiles[item.key]
                }
            ).map(
                (item) => {
                    console.log(item)
                    return {
                        uploaded_file_id: values.sendedFiles[item.key].id,
                        filename: item.file.name,
                        mimetype: item.file.type
                    }
                }
            )

            const response = await axios.post(
                `${FICHE_SEND_DOCUMENTS}/${id}`,
                {
                    files: data,
                    comment: values.comment
                }
            )

            formikHelpers.resetForm();
            loadSendedDocuments();

            console.log('send response', response)

        } catch (e) {
            console.log(e)
        } finally {
            formikHelpers.setSubmitting(false)
        }

    }

    React.useEffect(() => {
        loadSendedDocuments()
        loadDevis()
    }, [])

    return (
        <div>

            <div>


                <Formik
                    initialValues={{
                        files: [],
                        sendedFiles: {},
                        comment: ''
                    }}
                    onSubmit={sendDocuments}
                >

                    {
                        (formikHelpers) => {

                            return (

                                <div>

                                    <FieldArray
                                        name={'files'}
                                        render={(arrayUtils) => {
                                            return (
                                                <div className={'row animate'}>

                                                    <div className={clsx(
                                                        {
                                                            ['col-12']: formikHelpers.values.files.length == 0,
                                                            ['col-9']: formikHelpers.values.files.length > 0,
                                                        }
                                                    )}>
                                                        <label
                                                            className={'btn btn-light-primary my-3 btn-block'}>
                                                            Ajouter des documents à envoyer
                                                            <input onChange={
                                                                (event) => {

                                                                    for (let i = 0; i < event.target.files.length; i++) {

                                                                        const key = generateRandomString(9);

                                                                        arrayUtils.push({
                                                                            key,
                                                                            file: event.target.files[i]
                                                                        });

                                                                    }

                                                                }
                                                            } type="file"
                                                                   disabled={formikHelpers.isSubmitting}
                                                                   multiple="multiple"
                                                                   className={'d-none'}/>
                                                        </label>
                                                    </div>

                                                    {
                                                        Object.values(formikHelpers.values.sendedFiles).length > 0 && (
                                                            <div className="col-3">
                                                                <BootstrapLoadingButton
                                                                    disabled={formikHelpers.isSubmitting}
                                                                    onClick={formikHelpers.submitForm}
                                                                    className={'btn btn-block my-3 btn-light-success'}>
                                                                    Envoyer {Object.values(formikHelpers.values.sendedFiles).length > 0 && (
                                                                    <span
                                                                        className={'font-weight-bold'}>({Object.values(formikHelpers.values.sendedFiles).length})</span>
                                                                )}
                                                                </BootstrapLoadingButton>
                                                            </div>
                                                        )
                                                    }

                                                    {
                                                        formikHelpers.values.files.map(
                                                            (item, index) => {
                                                                return (
                                                                    <div key={item.key}
                                                                         className="col-md-6">
                                                                        <FileUploader
                                                                            disabled={formikHelpers.isSubmitting}
                                                                            onDeleteClicked={
                                                                                () => {

                                                                                    let newSendedFiles = {};

                                                                                    for (let prop in formikHelpers.values.sendedFiles) {

                                                                                        if (prop !== item.key)
                                                                                            newSendedFiles[prop] = formikHelpers.values.sendedFiles[props]

                                                                                    }


                                                                                    formikHelpers.setFieldValue(
                                                                                        'files',
                                                                                        formikHelpers.values.files.filter(
                                                                                            file => {
                                                                                                return file.key !== item.key
                                                                                            }
                                                                                        )
                                                                                    )


                                                                                    formikHelpers.setFieldValue(
                                                                                        'sendedFiles',
                                                                                        newSendedFiles
                                                                                    )


                                                                                }
                                                                            }
                                                                            onFileUploaded={
                                                                                (uploadResponse) => {
                                                                                    formikHelpers.setFieldValue(
                                                                                        'sendedFiles',
                                                                                        {
                                                                                            ...formikHelpers.values.sendedFiles,
                                                                                            [item.key]: uploadResponse
                                                                                        }
                                                                                    )
                                                                                }
                                                                            }
                                                                            file={item.file}
                                                                        />
                                                                    </div>
                                                                )
                                                            }
                                                        )
                                                    }


                                                    {
                                                        Object.values(formikHelpers.values.sendedFiles).length > 0 && (
                                                            <div className="col-12">
                                                                <TextArea
                                                                    onChange={(event) => {
                                                                        formikHelpers.setFieldValue('comment', event.target.value)
                                                                    }}
                                                                    value={formikHelpers.values.comment}
                                                                />
                                                            </div>
                                                        )
                                                    }


                                                </div>
                                            )
                                        }}
                                    />


                                </div>

                            )

                        }
                    }

                </Formik>

            </div>

            <div className={'my-5'}>
                <div className={'h3 text-primary'}>
                    <span className={'d-inline-block mr-4'}>Devis</span>
                    {
                        isLoadingDocuments && (
                            <CircularProgress size={14} />
                        )
                    }
                </div>

                <div>


                    {
                        devis && devis.map(
                            devisItem => {
                                return (
                                    <div className={'my-5 card'}>

                                        <div  className={'card-body row'}>

                                            <div className={'col'}>
                                                Devis du {moment(devisItem.created_at).format('DD/MM/Y')}
                                            </div>

                                            <div className={'col-auto'}>
                                                <a target={'_blank'} href={`${DOWNLOAD_SPECIFIC_DEVIS}/${devisItem.file_download_token}`} className={'btn  btn-light-primary'}>
                                                    <i className={'flaticon2-download'}></i> Télécharger
                                                </a>
                                            </div>

                                        </div>

                                        {/*<div className={'text-right small mt-2 text-success font-weight-bold'}>*/}

                                        {/*    Envoyer le 12/12/2222 22:22 par <span>Jacob</span>*/}

                                        {/*</div>*/}

                                    </div>
                                )
                            }
                        )
                    }


                </div>

            </div>

            <FichePlanRecolementViewer ficheId={id} />

            <div>

                <div className={'h3 text-primary'}>
                    <span className={'d-inline-block mr-4'}>Documents</span>
                    {
                        isLoadingDocuments && (
                            <CircularProgress size={14} />
                        )
                    }
                </div>

                <div>

                    {
                        documentsSend && Array.isArray(documentsSend) && documentsSend.map(
                            documentSend => {
                                return (

                                    <div className={'row my-5'}>

                                        {
                                            documentSend.documents.map(
                                                document => {
                                                    return (

                                                        <div className={clsx(
                                                            [
                                                                'col-6',
                                                            ]
                                                        )}>

                                                            <div className={classes.documentItem}>
                                                                <div className={'row no-gutters'}>

                                                                    <div className={clsx(['col-3',{
                                                                        'text-primary': documentSend.origin == 'admin',
                                                                        'text-success': documentSend.origin == 'client',
                                                                    }])}>
                                                                        <MimeTypeIcon type={document.mimetype}/>
                                                                    </div>

                                                                    <div
                                                                        className={clsx(
                                                                            ['col font-weight-bold small d-flex align-items-center', {
                                                                                'text-primary': documentSend.origin == 'admin',
                                                                                'text-success': documentSend.origin == 'client',
                                                                            }]
                                                                        )}>

                                                                        <div style={{wordWrap: "break-word"}}>
                                                                            {document.file_name.substr(0, 35)}{document.file_name.length > 35 && '...'}
                                                                        </div>

                                                                    </div>

                                                                    <div className="col-2">

                                                                        <a target={'_blank'} href={`${DOWNLOAD_DOCUMENT}/${document.file_download_token}`} className={clsx(['btn btn-icon',{
                                                                            'btn-light-primary': documentSend.origin == 'admin',
                                                                            'btn-light-success': documentSend.origin == 'client',
                                                                        }])}>
                                                                             <i className={'flaticon2-download'}></i>
                                                                        </a>
                                                                        
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>

                                                    )
                                                }
                                            )
                                        }

                                        <div className="col-12 small text-right ">
                                            {documentSend.comment}
                                        </div>

                                        <div className="col-12 my-4">
                                            <Divider />
                                        </div>

                                    </div>

                                )
                            }
                        )
                    }

                </div>

            </div>

        </div>
    )
}